import React, { useState, useEffect } from 'react';
import {
    Modal, Button, InputGroup, Dropdown, Form,
    Col, Container, Row
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import PetSearch from '../search/PetSearch';
import Datetime from 'react-datetime';
import moment from 'moment';
import DateFnsUtils from '@date-io/moment';
import {
  DatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import TimeField from 'react-simple-timefield'
import 'moment/locale/sv';
import { eventRendered } from '@syncfusion/ej2-schedule';
moment.locale('sv');

export default (props) => {

    const [bookingTypeId, setBookingTypeId] = useState(-1);
    const [start, setStart] = useState(null);
    const [startTime, setStartTime] = useState(null);
    const [end, setEnd] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const [description, setDescription] = useState('');
    const [bookingTypeName, setBookingTypeName] = useState("Välj kategori..");
    const [bookingId, setBookingId] = useState(-1);
    const [userId, setUserId] = useState(-1);
    const [userName, setUserName] = useState("Välj användare..");
    const [saveIsOk, setSaveIsOk] = useState(false);
    const [searchShown, setSearchShown] = useState(false);
    const [connectedPet, setConnectedPet] = useState(null);
    const [verifyDeleteShown, setVerifyDeleteShown] = useState(false);

    useEffect(() => {
        if (props.isEditing) {
            setBookingId(props.editingEvent.id);
            setBookingTypeId(props.editingEvent.extendedProps.bookingTypeId);
            setBookingTypeName(props.editingEvent.title);
            setStart(moment.parseZone(props.editingEvent.start).utc());
            setEnd(moment.parseZone(props.editingEvent.end).utc());
            setStartTime(moment.parseZone(props.editingEvent.start).utc().format('HH:mm'))
            setEndTime(moment.parseZone(props.editingEvent.end).utc().format('HH:mm'))
            //setStart(props.editingEvent.start);
            //setEnd(props.editingEvent.end);
            setUserId(props.editingEvent.extendedProps.userId);
            setUserName(props.editingEvent.extendedProps.userName);
            setDescription(props.editingEvent.extendedProps.description);
        }
        if (props.isAdding) {
            var utcStart = props.newEventDate == null ? null : 
                moment.parseZone(props.newEventDate).utc();
            var utcEnd = utcStart == null ? null : utcStart.clone()
            setStart(utcStart)
            setStartTime(utcStart == null ? null : utcStart.format('HH:mm'));
            setEnd(utcEnd == null ? null : utcEnd.add(30, 'minutes'));
            setEndTime(utcEnd == null ? null : utcEnd.format('HH:mm'));
            setDescription('');
            setBookingId(-1);
            setBookingTypeId(-1);
            setUserId(-1);
            setBookingTypeName("Välj kategori");
            setUserName("Välj användare");
        }
    }, [props.editingEvent, props.newEventDate, props.isAdding, props.isEditing]);

    // Validation
    useEffect(() => {
        setSaveIsOk(
            bookingTypeId !== -1 && 
            start !== null && 
            end !== null
        );
    }, [bookingTypeId, start, end, userId]);

    function saveEdit() {
        const query = `/api/booking`;
        const method = props.isAdding ? 'POST' : 'PUT';
        fetch(query,
            {
                method: method,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                cors: 'cors',
                body: JSON.stringify({
                    bookingId: bookingId,
                    start: moment.utc(getCompleteStart()).toDate(),
                    end: moment.utc(getCompleteEnd()).toDate(),
                    bookingTypeId: bookingTypeId,
                    description: description,
                    userId: userId,
                    petId: connectedPet?.petId
                })
            }).then(res => {
                if (res.status !== 200) {
                    res.json().then((resJson) => {
                        alert('Fel vid sparning: ' + resJson.error);
                        return;
                    });
                }
            }).catch(err => {
                alert('Fel vid sparning: ' + err);
                return;
            }
        );
        props.onSaved(bookingId);
    }

    function getCompleteStart() {
        return start.hour(startTime.split(':')[0]).minute(endTime.split(':')[1]);
    }

    function getCompleteEnd() {
        return end.hour(endTime.split(':')[0]).minute(endTime.split(':')[1]);
    }

    function onBookingTypeSelected(eventKey, _) {
        setBookingTypeId(eventKey);
        props.bookingTypes.forEach(bType => {
            if (bType.BookingTypeId.toString() === eventKey.toString()) {
                setBookingTypeName(bType.Name);
            }
        });
    }

    function onUserIdSelected(eventKey, _) {
        setUserId(eventKey);
        props.users.forEach(user => {
            if (user.UserId.toString() === eventKey.toString()) {
                setUserName(user.Initials);
            }
        });
    }

    function onDescriptionChanged(event) {
        setDescription(event.target.value);
    }

    function getTitle() {
        if (props.isEditing) {
            return (
                <Modal.Title>
                    Redigerar {props.editingEvent?.title}
                </Modal.Title>
            );
        }
        else if (props.isAdding) {
            return (
                <Modal.Title>
                    Skapa ny bokning
                </Modal.Title>   
            );
        }
        else {
            return <React.Fragment />;
        }
    }

    function onPetSelected(selection) {
        setSearchShown(false);
        setConnectedPet(selection);
    }

    function getCurrentPet() {
        if (connectedPet) {
            return connectedPet.petName;
        }
        else {
            return "Välj djur:";
        }
    }

    function deleteBooking() {
        setVerifyDeleteShown(false);
        const query = `/api/booking`;
        const method = 'DELETE';
        fetch(query,
            {
                method: method,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                cors: 'cors',
                body: JSON.stringify({
                    bookingId: bookingId,
                })
            }).then(res => {
                if (res.status !== 200) {
                    res.json().then((resJson) => {
                        alert('Fel vid borttagning: ' + resJson.error);
                        return;
                    });
                }
            }).catch(err => {
                alert('Fel vid borttagning: ' + err);
                return;
            }
        );
        props.onDelete(bookingId);
    }

    function onStartTimeChanged(time) {
        setStartTime(time);
    }

    function onEndTimeChanged(time) {
        setEndTime(time);
    }

    function onStartChanged(date) {
        setStart(date);
    }

    function onEndChanged(date) {
        setEnd(date);
    }

    return (
        <React.Fragment>
        <Modal size="lg" show={verifyDeleteShown} backdrop="static">
            <Modal.Body>
                Är du säker på att du vill ta bort bokningen?
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => setVerifyDeleteShown(false)}>
                    Avbryt
                </Button>
                <Button variant="danger" onClick={deleteBooking}>
                    Ja
                </Button>
            </Modal.Footer>
        </Modal>
        <Modal size="lg" show={props.show} onHide={props.onClosed} backdrop="static">
            <Modal.Header closeButton>
                {getTitle()}
            </Modal.Header>
            <Modal.Body>
                <InputGroup className="mb-2">
                    <Col className="my-auto">
                        Bokningskategori: 
                    </Col>
                    <Col className="my-auto text-right">
                        <Dropdown alignRight onSelect={onBookingTypeSelected}>
                            <Dropdown.Toggle id="dropdown-types">
                                {bookingTypeName}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {props.bookingTypes.map((type) => (
                                    <Dropdown.Item key={type.BookingTypeId} eventKey={type.BookingTypeId}>{type.Name}</Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>
                    </Col>
                </InputGroup>
                <InputGroup className="mb-2">
                    <Col className="my-auto">
                        Resurs: 
                    </Col>
                    <Col className="my-auto text-right">
                        <Dropdown alignRight onSelect={onUserIdSelected}>
                            <Dropdown.Toggle id="dropdown-types">
                                {userName}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {props.users.map((user) => (
                                    <Dropdown.Item key={user.UserId} eventKey={user.UserId}>{user.Initials}</Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>
                    </Col>
                </InputGroup>
                <InputGroup className="mb-2">
                    <Col className="my-auto">
                        {getCurrentPet()}
                    </Col>
                    <Col className="my-auto text-right">
                        <Button onClick={() => setSearchShown(true)}>
                            Sök..
                        </Button>
                    </Col>
                </InputGroup>
                <PetSearch
                    allowCreate={false} 
                    shown={searchShown}
                    onGoToPetJournal={onPetSelected}/>
                <hr />
                <InputGroup className="mb-2">
                    <Col xs={4} className="my-auto">
                        Starttid:
                    </Col>
                    <Col xs={4} className="my-auto">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DatePicker format="YYYY-MM-DD" onChange={onStartChanged} value={start} ampm={false}/>
                        </MuiPickersUtilsProvider>
                    </Col>
                    <Col xs={4}>
                        <TimeField style={{width: 60}} onChange={onStartTimeChanged} value={moment(start).format('HH:mm')} />
                    </Col>
                </InputGroup>
                <InputGroup className="mb-2">
                    <Col xs={4} className="my-auto">
                        Sluttid:
                    </Col>
                    <Col xs={4} className="my-auto">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DatePicker format="YYYY-MM-DD" onChange={onEndChanged} value={end} ampm={false}/>
                        </MuiPickersUtilsProvider>
                    </Col>
                    <Col xs={4}>
                        <TimeField style={{width: 60}} onChange={onEndTimeChanged} value={moment(end).format('HH:mm')} />
                    </Col>
                </InputGroup>
                <InputGroup className="mb-2">
                    <Col xs={4} className="my-auto">
                        Besöksorsak:
                    </Col>
                    <Col xs={8} className="my-auto text-right">
                        <Form.Control 
                            value={description}
                            onChange={onDescriptionChanged}
                            as="textarea" 
                            rows={3}>
                        </Form.Control>
                    </Col>
                </InputGroup>
            </Modal.Body>
            <Modal.Footer>
                <Container fluid>
                    <Row>
                        <Col>
                            <Button variant="danger" onClick={() => setVerifyDeleteShown(true)}>
                                <FontAwesomeIcon icon={faTrash} size="lg"></FontAwesomeIcon>
                            </Button>
                        </Col>
                        <Col>
                            <Button variant="secondary" onClick={props.onClosed}>
                                Stäng
                            </Button>
                        </Col>
                        <Col>
                            <Button disabled={!saveIsOk} variant="success" onClick={saveEdit}>
                                Spara
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Modal.Footer>
        </Modal>
        </React.Fragment>
    );
}